<template>
  <div class="logo">
    <!-- 登陆前的log -->
    <img
      v-if="name"
      src="@/assets/home/logo_logined@2x.png"
    >
    <!-- 登陆后的log -->
    <img
      v-else
      src="@/assets/home/logo_unlogin@2x.png"
    >
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'name',
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/utils.scss";
.logo{
  z-index: 1;
  position: absolute;
  top: 0;
  left: 24.4%;
  width: widthToPerc(349);
  height: heightToPerc(285);
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
